export const CONSENT_KEY = 'analytics_consent';
export const CONSENT_GRANTED = 'granted';
export const CONSENT_DENIED = 'denied';
export const OPEN_CONSENT_EVENT = 'acebit:open-cookie-settings';
